/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Map_Popup_Sessions_SubtitleInputs */

const en_ui_map_popup_sessions_subtitle = /** @type {(inputs: Ui_Map_Popup_Sessions_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions recorded near this location`)
};

const de_ui_map_popup_sessions_subtitle = /** @type {(inputs: Ui_Map_Popup_Sessions_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten in der Nähe dieses Ortes`)
};

/**
* | output |
* | --- |
* | "Sessions recorded near this location" |
*
* @param {Ui_Map_Popup_Sessions_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_popup_sessions_subtitle = /** @type {((inputs?: Ui_Map_Popup_Sessions_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_Popup_Sessions_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_popup_sessions_subtitle(inputs)
	return de_ui_map_popup_sessions_subtitle(inputs)
});